import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./module");

export default function initProductsLoader(context) {
    loadModuleOnElement('img[usemap ^="#image-map-"], [data-use-product-map="true"] .widget__head .widget__image', loader, context);
    return context;
}
